import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Radio} from 'semantic-ui-react';
import {transportTypes} from '../../../common/dictionaries/classification';
import {Actions} from '../../../common/actions';

class TransportSelector extends Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(event, data) {
    const {index} = this.props;
    this.props.updateTransport(index, data.value);
  }

  render() {
    const {index, value} = this.props;

    return transportTypes.map((option, i) => {
      return (
        <Radio
          key={i}
          name={`transport${index}`}
          label={option.text}
          value={option.value}
          checked={value === option.value}
          onChange={this.handleOptionChange}
        />
      );
    });
  }
}

const {updateTransport} = Actions;

export default connect(null, {updateTransport})(TransportSelector);
